export default __webpack_public_path__ + "static/media/dash.fba699e9.png";